import { useBlockAppearanceStylesContext } from '../../context/BlockAppearanceStylesContext';
import type { AppearanceStyles, StyleResult } from './types';

const useBlockAppearanceStyles = ({
  appearanceStyles,
}: {
  appearanceStyles: AppearanceStyles;
}): StyleResult => {
  // use the shared context instead of creating a new function each time
  const { processStyles } = useBlockAppearanceStylesContext();

  // call the shared function with the provided styles
  return processStyles(appearanceStyles);
};

export default useBlockAppearanceStyles;
